import { Tag, Typography } from "antd";
import React from "react";
import { FolderChange } from "../../../redux/interfaces/folder.types.ts";
import { gray, lightBlue } from "../../../utils/theme/colors.ts";

interface Props {
  change: FolderChange;
}

export const HistoryCollaborator: React.FC<Props> = ({ change }) => {
  const previousCollaborator = change.collaborator?.previous;
  const currentCollaborator = change.collaborator?.actual;

  return (
    <div className="flex items-center font-medium space-x-2 my-1">
      {currentCollaborator !== null && (
        <div className="flex flex-wrap">
          <Typography.Text className="font-medium">
            Colaborador:&nbsp;
          </Typography.Text>
          {previousCollaborator !== null &&
            previousCollaborator !== currentCollaborator && (
              <div className="mr-1">
                <Tag color={gray}>{previousCollaborator}</Tag>
                <span className="text-gray-500">→</span>
              </div>
            )}
          <Tag color={currentCollaborator ? lightBlue : gray}>
            {currentCollaborator}
          </Tag>
        </div>
      )}
    </div>
  );
};
